import { Injectable } from "@angular/core";
import { take } from "rxjs";
import { AuthenticationService } from "./authentication.service";
import { LoggerService } from "./logger.service";
import { BasicModalComponent } from "../modules/shared/components/basic-modal/basic-modal.component";
import { MatDialog } from "@angular/material/dialog";

@Injectable({
	providedIn: "root",
})
export class InitializerService {
	constructor(
		private readonly _authenticationService: AuthenticationService,
		private readonly _dialog: MatDialog
	) {}

	initializeApp(): Promise<any> {
		return new Promise((resolve, reject) => {
			this._authenticationService
				.getUserInfo()
				.pipe(take(1))
				.subscribe({
					next: (resp) => {
						LoggerService.logInfo(this.constructor.name, "getUserInfo", {
							resp,
						});
						if (resp && !resp.enabled) {
							this._dialog.open(BasicModalComponent, {
								data: {
									title: 'Accesso Non Autorizzato',
									text: 'Siamo spiacenti ma non sei abilitato ad accedere.',
									modalSize: 'modal-box-small text-center vertical-align',
								},
								disableClose: true,
							});
							reject();
						} else {
							resolve(true);
						}
					},
					error: (err) => {
						LoggerService.logError(this.constructor.name, "initializeApp", {
							err,
						});
						alert(
							"Accesso non consentito all'applicativo. Contattare Help Desk."
						);
						reject();
					},
				});
		});
	}
}
